/* global clearNotifications */
import { createRouter, createWebHistory } from 'vue-router'

let locale = window.location.pathname.slice(1, 3) ?? 'lv'

const router = createRouter({
    history: createWebHistory(`/${locale}`),
    routes: [{
        path: '/Article/Author/:authorCode',
        name: 'Author',
        beforeEnter: [clearNotifications],
        component: () => import('@/components/articles/ArticleList.vue'),
    }, {
        path: '/Article/Read/:alias',
        name: 'Article',
        beforeEnter: [clearNotifications],
        component: () => import('@/components/articles/Article.vue'),
    }, {
        path: '/Article/Category/:categoryCode',
        name: 'Category',
        beforeEnter: [clearNotifications],
        component: () => import('@/components/articles/ArticleList.vue'),
    }, {
        path: '/Article',
        name: 'Articles',
        component: () => import('@/components/articles/ArticleList.vue'),
    }, {
        path: '/UserAgreement',
        name: 'UserAgreement',
        component: () => import('@/components/articles/Article.vue'),
    }, {
        path: '/DataProcessingRules',
        name: 'DataProcessingRules',
        component: () => import('@/components/articles/Article.vue'),
    }, {
        path: '/Article/Search/:query',
        redirect: to => {
            // redirect to upper one; not used anymore
            return { name: 'Articles', query: { search: to.params.query } }
        }
    }, {
        path: '/Article/View/:UId',
        redirect: to => {
            // /Article/Read/{alias}; not used anymore
            return { name: 'Article', params: { alias: to.params.UId } }
        }
    }],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
            
        } else {
            return {
                top: 0,
                behavior: 'smooth',
            }
        }
    },
})

export default router